// ----------------------------------------------------------------------------
// Component: Veritree Stats
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import '../../snippets/icon/icon';

// Styles
import './_veritree-stats.scss';


// -------------------------------------
// Functionality
// -------------------------------------


const setVeritreeStats = data => {
    // Blocks
    const total_trees_blocks = document.querySelectorAll('[data-veritree-fact="total_trees"]');
    const total_co2_blocks = document.querySelectorAll('[data-veritree-fact="tonnes_of_CO2"]');
    const total_reforested_blocks = document.querySelectorAll('[data-veritree-fact="hectares_reforested"]');

    total_trees_blocks.forEach(tree_block => {
        const tree_block_value = tree_block.querySelector('.js-veritree-value');
        const tree_block_desc_fact = tree_block.querySelector('.js-veritree-comparison');
        const trees_stat = data.data.trees_ordered;

        const tree_block_desc_fact_number = Math.round((trees_stat / 600) * 10.7148);
        tree_block_value.innerHTML = new Intl.NumberFormat().format(trees_stat);
        tree_block_desc_fact.innerHTML = new Intl.NumberFormat().format(tree_block_desc_fact_number);
    })

    total_co2_blocks.forEach(co2_block => {
        const co2_block_value = co2_block.querySelector('.js-veritree-value');
        const co2_block_desc_fact = co2_block.querySelector('.js-veritree-comparison');
        const co2_stat = data.data.impacts.co2_designated_projected_stat

        const co2_block_desc_fact_number = Math.round(co2_stat / 4.6);

        co2_block_value.innerHTML = new Intl.NumberFormat().format(Math.round(co2_stat));
        co2_block_desc_fact.innerHTML = new Intl.NumberFormat().format(co2_block_desc_fact_number);
    })

    total_reforested_blocks.forEach(reforested_block => {
        const reforested_block_value = reforested_block.querySelector('.js-veritree-value');
        const reforested_block_desc_fact = reforested_block.querySelector('.js-veritree-comparison');
        const impact_stat = data.data.impacts.area_planted_ordered_projected_stat;

        const reforested_block_desc_fact_number = Math.round(impact_stat * 20);

        reforested_block_value.innerHTML = new Intl.NumberFormat().format(Math.round(impact_stat));
        reforested_block_desc_fact.innerHTML = new Intl.NumberFormat().format(reforested_block_desc_fact_number);
    })
}

const fetchVeritreeStats = () => {
    fetch('https://api.veritree.com/api/orgs/pstats?org_id=149&org_type=sponsorAccount&_result=1').then(function (response) {
	// The API call was successful!
        if (response.ok) {
            return response.json();
        } else {
            return Promise.reject(response);
        }
    }).then(function (data) {
        // This is the JSON from our response
        setVeritreeStats(data);

    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });
}


document.addEventListener('DOMContentLoaded', function(event) {
    fetchVeritreeStats();
})
